"use client";
import React from "react";
import { useTranslations } from "next-intl";
import MaxWidthDiv from "./max-width-div";
import IconText from "./icon-text";
import { useMediaQuery } from "usehooks-ts";

import { MobileNavbar } from "./mobile-navbar";
import DesktopNavbar from "./desktop-navbar";
import LanguageSwitcher from "./language-switcher";

export interface NavbarItem {
  label: string;
  href?: {
    it: string;
    en: string;
  };
  children?: NavbarItem[];
}

export default function Navbar() {
  const t = useTranslations("navbar");
  const isMobile = useMediaQuery("(max-width: 1023px)", {
    initializeWithValue: false,
  });

  const items: NavbarItem[] = [
    {
      label: t("homepage"),
      href: { it: "/it", en: "/en" },
    },
    {
      label: t("aboutUs"),
      href: { it: "/it/chi-siamo", en: "/en/about-us" },
    },
    {
      label: t("menu"),
      children: [
        {
          label: t("restaurantMenu"),
          href: { it: "/it/menu", en: "/en/menu" },
        },
        {
          label: t("eventMenu"),
          href: { it: "/it/menu-eventi", en: "/en/menu-eventi" },
        },
      ],
    },
    {
      label: t("catering"),
      href: { it: "/it/catering", en: "/en/catering" },
    },
    {
      label: t("residence"),
      href: { it: "/it/residence", en: "/en/residence" },
    },
    {
      label: t("freshPasta"),
      href: { it: "/it/pasta-fresca", en: "/en/fresh-pasta" },
    },
    {
      label: t("contact"),
      href: { it: "/it/contatti", en: "/en/contact" },
    },
  ];

  return (
    <header>
      <div className="h-[70px] md:h-0 bg-card"></div>
      <MaxWidthDiv
        externalClassName="bg-card text-card-foreground hidden lg:block"
        className="flex flex-row justify-center pt-6 py-[24px] items-center relative"
      >
        <IconText />
        <LanguageSwitcher className="absolute right-4 md:right-6" />
      </MaxWidthDiv>
      <MaxWidthDiv
        externalClassName="bg-card text-card-foreground md:border-y border-y-muted"
        className="flex justify-between items-center p-4 fixed md:static left-0 right-0 top-0 bg-card z-10 h-[70px] md:h-auto border-b border-muted md:border-0"
      >
        {isMobile ? (
          <MobileNavbar items={items} />
        ) : (
          <DesktopNavbar items={items} />
        )}
      </MaxWidthDiv>
    </header>
  );
}
